import React, { createContext, useState, useEffect } from "react";
import apiService from "../Common/ApiCommon/ApiService";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userData, setUserData] = useState({
    userName: localStorage.getItem("userName") || "",
    userType: localStorage.getItem("userType") || "",
    userId: localStorage.getItem("userId") || "",
  });
  const [notificationTrigger, setNotificationTrigger] = useState(false);

  const triggerNotificationRefresh = () => {
    setNotificationTrigger(prev => !prev);
  };

  // Function to update userData after login
  const updateUserData = (newData) => {
    setUserData(prev => ({ ...prev, ...newData }));


    // Store in localStorage for persistence
    localStorage.setItem("userName", newData.userName);
    localStorage.setItem("userType", newData.userType);
    localStorage.setItem("userId", newData.userId);
  };
  useEffect(() => {
    const interval = setInterval(() => {
      triggerNotificationRefresh();
    }, 60000); 

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchUserData = async () => {
      if (userData.userId && userData.userType) {
        try {
          let response;
          if (userData.userType === "vendor") {
            response = await apiService.get(`/vendors/${userData.userId}`);
          } else if (userData.userType === "staff") {
            response = await apiService.get(`/staff_users/${userData.userId}`);  
          }

          if (response && response.status === 200) {
            setUserData(prev => ({
              ...prev,
              ...response.data,
              userId: response?.data?.id,
            }));
          }
        } catch (error) {
          console.error("Error fetching vendor data:", error);
        }
      }
    };

    fetchUserData();
  }, [userData.userId, userData.userType]); // Runs when userId/userType changes

  return (
    <UserContext.Provider value={{ userData, updateUserData, notificationTrigger, triggerNotificationRefresh }}>
      {children}
    </UserContext.Provider>
  );
};
